import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { FixedSizeList, ListChildComponentProps } from "react-window";

// Reusable ReportBox Component
function ReportBox({
  title,
  listItems,
  onItemClick,
}: {
  title: string;
  listItems: string[];
  onItemClick: (item: string) => void;
}) {
  const renderRow = (props: ListChildComponentProps) => {
    const { index, style } = props;

    return (
      <ListItem style={style} key={index} component="div" disablePadding>
        <ListItemButton onClick={() => onItemClick(listItems[index])}>
          <ListItemText primary={listItems[index]} sx={{ color: "#111827" }} />
        </ListItemButton>
      </ListItem>
    );
  };

  return (
    <Box
      sx={{
        width: "300px", // Set a fixed width
        //height: 320, // Set height for the box
        maxWidth: "100%", // Ensure it's responsive
        bgcolor: "background.paper",
        border: "1px solid #ddd", // Add border
        borderRadius: "8px", // Add rounded corners
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        display: "flex", // Use flexbox to position content inside
        flexDirection: "column", // Ensure content inside is stacked vertically
        justifyContent: "start", // Center the content vertically if needed
        margin: "0px", // Space between boxes
      }}
    >
      <Typography
        // variant=""
        sx={{
          textAlign: "center",
          p: 1,
          borderBottom: "1px solid #ddd",
          bgcolor: "#e9e9e9",
          color: "#1D1D1D",
          fontSize: "18px",
        }}
      >
        {title}
      </Typography>

      <FixedSizeList
        height={48}
        width={"100%"}
        itemSize={46}
        itemCount={listItems.length}
        overscanCount={listItems.length}
        font-size={18}
      >
        {renderRow}
      </FixedSizeList>
    </Box>
  );
}

export default ReportBox;
